// src/utils/upsell.js — the suggested items shown when staff click Print KOT (editable in Admin Panel → Suggested Items)
export const DEFAULT_UPSELL_ITEMS = [
  { id: 'sd1', name: 'Stuffed Garlic Bread', emoji: '🥖', price: 129 },
  { id: 'sd2', name: 'Choco Lava',           emoji: '🍫', price: 109 },
  { id: 'f1',  name: 'French Fries',         emoji: '🍟', price: 39  },
  { id: 'pa1', name: 'Veg Pasta',            emoji: '🍝', price: 129 },
];